/** Display-only: drops weeks with nothing logged so empty gaps don't read as a crash. */
export function activeWeeks(trend, key) {
  const weeks = trend || [];
  const kept = weeks.filter((w) => (w[key] || 0) > 0 || w.is_current);
  return kept.length > 1 ? kept : weeks;
}
